import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    // clinics: typeof window !== 'undefined' && (localStorage.getItem('clinicsList') ? (JSON.parse(localStorage.getItem('clinicsList'))) : []),
    clinics: [],
    // selectedClinic: typeof window !== 'undefined' && JSON.parse(localStorage.getItem('clinic')) || {},
    selectedClinic: { clinicId: null, clinicName: "" },
    loading: false,
    error: false,
    clinicTabsValue: 0,
}

const clinicSlice = createSlice({
    name: "clinics",
    initialState,
    reducers: {
        fetchClinicsRequest: (state, action) => {
            state.loading = true
        },
        fetchClinicsSuccess: (state, action) => {
            state.loading = false
            state.clinics = action.payload
            // localStorage.setItem('clinicsList', JSON.stringify(action.payload || []))
        },
        fetchClinicsFailure: (state, action) => {
            state.loading = false
            state.error = action.payload
            state.clinics = []
            if (typeof window !== "undefined") localStorage.setItem("clinicsList", [])
        },
        updateSelectedClinic: (state, action) => {
            state.selectedClinic = action.payload
            if (typeof window !== "undefined" && action.payload?.clinicId) {
                localStorage.setItem(
                    "lastSelectedClinicId",
                    String(action.payload.clinicId)
                )
            }
        },
        updateClinicsTabValue: (state, action) => {
            state.clinicTabsValue = action.payload
        },
    },
})

export const {
    fetchClinicsFailure,
    fetchClinicsRequest,
    fetchClinicsSuccess,
    updateSelectedClinic,
    updateClinicsTabValue,
} = clinicSlice.actions

export default clinicSlice.reducer
